import { render, staticRenderFns } from "./videoOptions.vue?vue&type=template&id=6f571f6e&scoped=true&lang=pug&"
import script from "./videoOptions.vue?vue&type=script&lang=js&"
export * from "./videoOptions.vue?vue&type=script&lang=js&"
import style0 from "./videoOptions.vue?vue&type=style&index=0&id=6f571f6e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f571f6e",
  null
  
)

export default component.exports